import { isNullishOrEmpty } from "@commonHelpers/math-utils";
import { environment } from "@environments/environment";

// Reine Konfiguration - keine Provider, keine Laufzeitabhängigkeit auf den Interceptor. Der
// Interceptor liest apiAccesses von hier; stünde sein Provider ebenfalls hier, wäre das ein
// Importzyklus (Begründung in msalb2c.interceptor.provider.ts).
export const apiAccesses: string[] = [
	environment.accountApi,
	environment.analyticsApi,
	environment.catalogApi,
	environment.exportApi,
	environment.importApi,
	environment.naturalLanguageProcessingApi,
	environment.keywordsApi,
	environment.protocolApi,
	environment.searchApi,
	environment.ftpApi
].filter((apiAccess): apiAccess is string => !isNullishOrEmpty(apiAccess));
